export class AssignTariffFilter {
    general: string;
}